import { DEFAULT_PAGE_SIZE } from './constants';

export const getPageBoundaries = (currentPage: number, itemCount = 0) => {
  const firstEntry = Math.min(currentPage * DEFAULT_PAGE_SIZE, itemCount - 1);
  const lastEntry = Math.min(
    (currentPage + 1) * DEFAULT_PAGE_SIZE - 1,
    itemCount - 1
  );

  return [firstEntry, lastEntry];
};

export const getFullscreenPageBoundaries = (itemCount = 0) => {
  if (itemCount <= 0) {
    return [-1, -1];
  }

  return [0, itemCount - 1];
};
